import type { Chapter } from "@/shared/api/book";
import { Chip } from "@/shared/ui/chip";
import { Label } from "@/shared/ui/label";

/** Több fejezet választása beküldő űrlapokon (chip-ek, érintésbarát célpontokkal).
 *  Minden fejezethez köthető elem több fejezetet is kaphat — rendszerterv 8. */
export function ChapterPicker({
  label,
  chapters,
  value,
  onChange,
  hint = "Több is választható; ha nem tudod, hagyd üresen.",
}: {
  label: string;
  chapters: Chapter[];
  value: number[];
  onChange: (ids: number[]) => void;
  hint?: string;
}) {
  const flat = chapters.flatMap((c) => [c, ...c.children]);
  const toggle = (id: number) =>
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);

  return (
    <div className="flex flex-col gap-2">
      <Label>{label}</Label>
      <div className="flex flex-wrap gap-1.5">
        {flat.map((c) => {
          const active = value.includes(c.id);
          return (
            <button
              key={c.id}
              type="button"
              aria-pressed={active}
              onClick={() => toggle(c.id)}
              className={
                active
                  ? "rounded-chip bg-gold-soft px-2.5 py-1.5 text-[12px] font-semibold text-gold-text"
                  : "rounded-chip border border-line px-2.5 py-1.5 text-[12px] font-semibold text-muted hover:bg-paper"
              }
            >
              {c.number}. {c.title}
            </button>
          );
        })}
      </div>
      <p className="text-[12px] text-muted">
        {value.length > 0 ? <Chip variant="neutral">{value.length} fejezet</Chip> : hint}
      </p>
    </div>
  );
}
